import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import new_logo from "assets/images/logo/big_barrister_white.png";
import { useSelector } from "react-redux";
import { RootState } from "Slices/theme/store";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  const isAuthenticated = useSelector(
    (state: RootState) => state.theme.isAuthenticated
  );
  const token = Cookies.get("token");

  // console.log("isAuthenticated", isAuthenticated);

  return (
    <footer className="theme-footer">
      <div className="pre-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="footer-logo text-center">
                <img
                  src={new_logo}
                  alt="logo"
                  className="img-responsive"
                  width="200"
                  height="100"
                />
              </div>
              <div className="footer-menu">
                <ul>
                  {isAuthenticated || token || (
                    <>
                      <li>
                        <Link to="/login">Sign In</Link>
                      </li>
                      {/* <li>
                        <Link to="/admin/login">Admin Login</Link>
                      </li> */}
                    </>
                  )}
                  {/* <li>
                    <Link to="/pricing">Price</Link>
                  </li> */}
                  <li>
                    <Link to="/about"> About Us</Link>
                  </li>
                  {/* <li>
                    <Link to="/privacy-regulations">Datenschutzerklärung</Link>
                  </li>
                  <li>
                    <Link to="/impressum">Impressum</Link>
                  </li> */}
                  {/* <li>
                    <a href="#">Erklärung zur Barrierefreiheit</a>
                  </li> */}
                  {/* <li>
                    <Link to="/terms-conditions">Terms & Conditions</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/cancellation-declaration">
                      Widerrufserklärung
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
              <div className="footerAbout">
                <p className="mb-0">
                  The information provided on this website is for general
                  information purposes only and does not constitute legally
                  binding information or advice. We strive to keep the content
                  up-to-date and correct, but we assume no liability for the
                  completeness, accuracy, or timeliness of the information
                  provided.
                </p>
              </div>
              {/* <div className="footerSocial text-center mt-4">
                <Link
                  to="https://www.instagram.com/strafinfo.de/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faInstagram} size="xl" color="#fff" />
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="copyright-area-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="copyright-area-bottom-inn">
                <p>
                  © 2025 <Link to="/">Big Barrister </Link>.  All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
